import { RefProps } from "./types";
export const applyItem = (basePath, targetPath) => {
  let isDiff = false;
  const basePathArr = (basePath !== null && basePath !== void 0 ? basePath : "").split(".");
  const targetPathArr = (targetPath !== null && targetPath !== void 0 ? targetPath : "").split(".");
  const result = targetPathArr.map((item, idx) => {
    if (item === "*" && !isDiff) {
      return basePathArr[idx];
    }
    if (item !== basePathArr[idx]) {
      isDiff = true;
    }
    return item;
  });
  return result.join(".");
};
export const popPath = (path) => {
  if (!path) {
    return {
      parent: "",
      name: ""
    };
  }
  const pathArr = path.split(".");
  const name = pathArr[pathArr.length - 1];
  const parent = pathArr.slice(0, pathArr.length - 1).join(".");
  return {
    parent,
    name
  };
};
export const createFieldPath = (fieldPath, name) => fieldPath;
export const popFieldpath = (path) => ({
  parent: path.parent(),
  name: path[RefProps.name]()
});
export const getNoVoidPath = (voidPathMap, path) => {
  if (!path) {
    return "";
  }
  const { parent, name } = popFieldpath(path);
  const isVoid = voidPathMap.get(path);
  const noVoidParent = getNoVoidPath(voidPathMap, parent);
  const showName = isVoid ? "" : name;
  if (!showName) {
    return noVoidParent;
  }
  return noVoidParent ? `${noVoidParent}.${showName}` : showName;
};
var _aliasMap_get;
export const getShowName = (aliasMap, path, originName) => (_aliasMap_get = aliasMap.get(path)) !== null && _aliasMap_get !== void 0 ? _aliasMap_get : originName;
export const getShowPath = (aliasMap, path) => {
  if (!path) {
    return "";
  }
  const { parent, name } = popFieldpath(path);
  const parentShowPath = getShowPath(aliasMap, parent);
  return parentShowPath ? `${parentShowPath}.${name}` : name;
};
export const isAttr = (path) => {
  var _path;
  return Boolean(path) && Boolean(!((_path = path) === null || _path === void 0 ? void 0 : _path[RefProps.withAttr]));
};
const checkFieldPathProps = [
  RefProps.name,
  RefProps.nameCollection,
  RefProps.noVoidPath,
  RefProps.path
];
export const isFieldPath = (path) => checkFieldPathProps.every((item) => Boolean(path[item]));
